import React from 'react';
import AcquireWebComponent from '../../framework/MaterialUI';
import Select from 'react-select';
import Search from 'material-ui/svg-icons/action/search'
import { apiBaseUrl} from '../../../env';
import sortBy from 'lodash/sortBy';
import remove from 'lodash/remove';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';

class AsyncSearchBar extends AcquireWebComponent {
	constructor(props) {
		super(props);
		this.state = {
			optionsArr: [],
      selectedItem: undefined, 
			disabledAllClientsOption : true,
			isSearching: false
		};
	}

	componentWillReceiveProps (nextProps) {
    if (this.props.clients !== nextProps.clients){
      this.initializeClientList(this.state.disabledAllClientsOption, nextProps.clients)
    }
	}
	
  componentDidMount(){
    if (this.props.clients)
      this.initializeClientList(this.state.disabledAllClientsOption, this.props.clients)
  }

	processClientList(clients, filterIds, input) {
		let clientsList = []
		if (input)
			input = input.trim()
		if (clients){
      const sortedClients = sortBy(clients, function(c){
        return c.name.toLowerCase()
      })

      if ((clients.length === 1) && (clients[0].id <= 1)){
        clientsList = remove(clientsList, function(c){
          return c.id !== 0
        })
      }
      sortedClients.forEach(function(item){
        if (item.id > 1){
          clientsList.push({id: item.id, name: item.name})
          if (!isEmpty(item.businessUnits)){
            const sortedSubClients = sortBy(item.businessUnits, function(c){
              return c.name.toLowerCase()
            })
            sortedSubClients.forEach(function(sc){
              clientsList.push({id: sc.id, name: '      ' + sc.name})
            })
          }
        }
			})
			
			if (filterIds){
				const result = filter(clientsList, function(c){
					return filterIds.indexOf(c.id) >= 0;
				})
				if (input){
					const {bizUnitUsers, clientUsers} = this.props.resultSet;
					map(clientUsers.data, function(item, key){
						if (item.clientName.indexOf(input) < 0){
							const {user} = item;
							if (user.username.indexOf(input) >= 0){
								const idx = findIndex(result, {id: item.clientId});
								result.splice(idx, 1, {id: item.clientId, name: user.username});
							} else if (user.email.indexOf(input) >= 0){
								const idx = findIndex(result, {id: item.clientId});
								result.splice(idx, 1, {id: item.clientId, name: item.user.email});
							}						
						}
					})					
					map(bizUnitUsers, function(users, key){
						const usersResult = filter(users, function(u){
							return ((u.clientName.indexOf(input) < 0) && ((!u.bizUnitName) || (u.bizUnitName.indexOf(input) < 0)))
						});
						map(usersResult, function(item){
							if (item.user.username.indexOf(input) >= 0){
								const idx = findIndex(result, {id: item.clientId});
								result.splice(idx, 1, {id: item.clientId, name: item.user.username});
							} else if (item.user.email.indexOf(input) >= 0){
								const idx = findIndex(result, {id: item.clientId});
								result.splice(idx, 1, {id: item.clientId, name: item.user.email});
							}
						});
					})
				}

				return result
			}
		}
		return clientsList
	}

	initializeClientList(disabledAllClientsOption, clients){
    disabledAllClientsOption = true
    let clientsList =  this.processClientList(clients)

    this.setState({
      optionsArr:clientsList,
      clientAdminMode: this.props.roleId > 1 && this.props.roleId < 10,
      businessUserMode: this.props.roleId > 50,
      businessAdminMode: this.props.roleId === 51
    })
    if (((disabledAllClientsOption === true) &&
      (parseInt(this.props.selected_client, 10) === 0) && (clientsList.length > 1)) ||
      (this.props.roleId > 50 && parseInt(this.props.selected_client, 10) === 0))  {
      if (clientsList.length > 1){
        this.setState({optionVal: clientsList[1].id})
        this.props.selectClient(clientsList[1].id)
      }
    }
	}
	
	filterOption(option, filterString){
		return option
	}
	
	optionRenderer(option){
    return (<span>{option.label}</span>)
  }

	handleOnChange (selectedItem) {
    if (selectedItem === null) {
      this.setState({
				selectedItem: undefined
      })
    } else {
      this.setState({
				selectedItem: selectedItem
      })
    }
	}

	getClients (input) {
		if (!input || input.length < 3) {
			return Promise.resolve({ options: [] });
		}
		const header = {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': this.props.token,
				'Cache-Control': 'no-cache',
				'max-age': 0
		}
		const url = `${apiBaseUrl}/clients/search?q=` + encodeURIComponent(input)
		return fetch(url, {method:"GET", headers: header})
		.then((response) => response.json())
		.then((json) => {
			const result = this.processClientList(this.props.clients, json.clientIds, input)
			const clientOptions = []
			result.forEach((item, index) => {
				clientOptions.push({value: item.id.toString(), label: item.name})
			})
			return { options: clientOptions };
		});
	}

	handleSearch () {
		if (this.state.selectedItem)
			this.props.handleSearch(this.state.selectedItem.value);
		else
			this.props.handleSearch("");
  }
	
	render() {		
		return (
			<div className="subscription-typeahead clearfix">
			<span className="s">Search</span>
			<div className="type-ahead-container">
				<Select.Async
					name=""
					placeholder=""
					multi={false}
					value={this.state.selectedItem}
					clearable={false}
					optionRenderer={(val) => this.optionRenderer(val)}
					onChange={(val) => this.handleOnChange(val)}
					filterOption={this.filterOption.bind(this)}
					loadOptions={this.getClients.bind(this)}
					valueKey={"value"}
					labelKey={"label"}
				/>
			</div>
			<button onClick={() => this.handleSearch()} style={{cursor:'pointer'}}>
				<Search
					style={{color: 'white'}}
				/>
			</button>
		</div>
		)
	}
}

export default AsyncSearchBar;


// WEBPACK FOOTER //
// ./src/components/SubscriptionsInfo/SearchBar/AsyncSearchBar.jsx